<template>
  <div class="userCentRightCens">
    <!-- <p>最近直播</p> -->
    <div class="love-two-title">
      <div class="text">
        <div>最近直播</div>
        <img class="icon" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/tips.png">
      </div>
    </div>
    <!-- 缩宽 -->
    <div class="userCentRightCenss">
      <div class="week-list">
        <div v-for="(item, index) in times" :key="index" class="week-item" :class="same_day == item.date ? 'on' : ''"
          @click="select(item.date)">
          <div class="day">{{ item.day }}</div>
          <div class="week">
            {{ weekEnum[item.week] ? weekEnum[item.week].slice(2) : "" }}
          </div>
        </div>
      </div>
      <div class="ov-box">
        <div v-for="(item, index) in zb" :key="index" class="daytCont" @click="gkZb(item)">
          <div class="courseName">{{ item.courseName }}</div> 
          <div class="dfbox">
            <img :src="item.surfacePlot" class="item-img">
            <div class="content">
              <div class="zjTitle twoEllipsis">{{ item.title }}</div>
              <div class="dateBox">
                <div v-if="item.liveCourseStatus == 0" class="date">
                  {{
                    `${item.liveliveStartTime.substring(
                      5,
                      7
                    )}月${item.liveStartTime.substring(
                      8,
                      10
                    )}日 ${item.liveStartTime.substring(11, 16)}开播`
                  }}
                </div>
                <div v-else class="date">
                  {{ `${item.liveStartTime.substring(5, 16)}` }}
                </div>
                <div v-if="item.liveCourseStatus != 0" class="but fr" @click.stop="gkZb(item, 1)">
                  {{ item.liveCourseStatus == 1 ? "直播中" : "看回放" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="daytCon">
        <!-- 直播课表内容1 -->
      </div>
    </div>
    <!-- 是否可以观看弹窗 -->
    <div v-if="showLookDetail" class="lookBg">
      <div class="ifLook">
        <div class="prompt">提示</div>
        <div class="contents">
          您当前正在<span>{{ lookDeatil ? lookDeatil.terminal : "" }}</span>观看<span>{{ lookDeatil ? lookDeatil.chapterName :
            ""
            }}</span>,请关闭后再行观看其他章节。
        </div>
        <div class="button" @click="closeLook">关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
// import { getDnsOneApi } from '@/api/home'
// import {
//   getUnderwayPcAllList, 
//   getUserCurTracking
// } from '@/api/user'
import { TimeFunction } from '@/api/TimeFunction'
const timeFunction = new TimeFunction()
import Vue from 'vue'
import { weekEnum } from '@/api/emun'
// import { courseCheckPlay } from '@/api/know'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},

  data() {
    return {
      sub: '',
      tenantId: '',
      weekEnum: weekEnum,
      times: [],
      survey: '', // 学习概况
      name: '',
      same_day: '',
      names: '',
      zb: [],
      imageUrl: '',
      user: '',
      weekday: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ],
      lookDeatil: null,
      showLookDetail: false
    }
  },
  async created() {

    await this.getDate()
    this.userId = localStorage.getItem('userId')

    this.getList()
  },
  methods: {
    // 最近直播时间
    async getDate() {
      this.times = []
      for (let i = 0; i < 7; i++) {
        timeFunction.fun_date(i).then((res) => {
          const data = {
            date: res,
            day: new Date(res).getUTCDate(),
            week: i == 0 ? 7 : Number(new Date(res).getUTCDay())
          }
          if (i == 0) {
            this.same_day = data.date
          }
          this.times.push(data)
        })
      }
    },

    closeLook() {
      this.showLookDetail = false
    },
    // 调用获取学生直播课信息(点击)res.code==0
    getList() {
      homeClient.getRecentLiveList({ date: this.same_day }).then((res) => {
        if (res.code == 0) {

          this.zb = res.data

        }
      })
    },

    select(iemw) {
      this.same_day = iemw
      // 调用获取学生直播课信息
      this.getList()
    },


    // // 直播
   async gkZb(item) {
      
    await homeClient.checkIsBuyByCommodityId({
        liveId: item.liveId||item.courseId,
      }).then((res) => {
        if (res.code == 0) {
          this.ifHave = !res.data
        }
      })
      if (this.ifHave) {
        return
      }
      if (item.liveCourseStatus == 0) {
        this.$message.error('课程还未到开播时间')
        return
      }
      if (item.liveCourseStatus == 2) {
        this.$message.error('课程直播结束')
        return
      }
      const sub = {
        id: item.chapterId, 
      };
      for (const key in sub) {
        if (!sub[key] && sub[key] !== 0) {
          delete sub[key];
        }
      }
      const data = Vue.prototype.export(sub);
      const routeUrl = this.$router.resolve({
        path: `/livebofang?${data}`,
      });
      if (item.liveCourseStatus == 3 || item.liveCourseStatus == 1) {
        window.open(routeUrl.href, "_blank");
      } else {
        this.$notify({
          title: "提示",
          message: "该视频暂不可播放",
          type: "warning",
        });
      }


    }


  }
}
</script>
<style lang="less" scoped>
:v-deep .active {
  color: green !important;
}

.userCentRightCens {
  width: 90%;
  height: auto;
  margin: auto;

  // 标题
  p {
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #27323f;
  }

  // 缩宽
  .userCentRightCenss {
    width: 98%;
    height: auto;
    margin: auto;

    .ov-box {
      overflow-y: scroll;
      scrollbar-width: none;
      height: 348px;
      margin-top: 32px;

      .daytCont {
        width: 100%;
        opacity: 1;
        // cursor: pointer;
        margin-bottom: 16px;
        // display: flex;
        // padding: 16px;

        .courseName {
          color: #777777;
          margin-bottom: 2px;
          height: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          // line-height: 20px;

          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }

        .dfbox {
          display: flex;

          .item-img {
            flex-shrink: 0;
            width: 128px;
            height: 72px;
            background: #c4c4c4;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-right: 12px;
          }

          .content {
            width: 100%;
            height: 100%;

            .zjTitle {
              height: 40px;
              font-size: 14px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }

            .dateBox {
              display: flex;
              justify-content: space-between;

              align-items: flex-end;

              .date {
                color: #888888;
                font-size: 12px;
                margin-top: 5px;
              }

              .but {
                cursor: pointer;
                margin-top: 8px;
                float: right;
                width: 52px;
                height: 24px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                opacity: 1;
                border: 1px solid #ff5e51;
                font-size: 12px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #ff5e51;
                line-height: 22px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}

.week-list {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .week-item {
    width: 86px;
    // height: 124px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    text-align: center;
    justify-content: space-between;
    padding-top: 24px;

    .day {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #dddddd;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #666666;
      margin-bottom: 8px;
      cursor: pointer;
    }

    .week {
      height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
    }
  }

  .on {
    .day {
      background: #ff5d51;
      box-shadow: 0px 2px 4px 1px rgba(255, 19, 0, 0.30000001192092896);
      color: #fff !important;
    }
  }
}

.love-two-title {
  margin: 0px 4px;
  padding: 20px 0px;
  border-bottom: 1px solid #eee;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
